import { useDefaultDataLayer } from '../useDataLayer';

/** * Hook for tracking menu actions
 */
export function useMenuInteractionTracking() {
  const { registerAction } = useDefaultDataLayer();

  /**
   * Tracks a menu interaction event.
   * @param {string} downloadLink - The link to the download, if applicable.
   * @param {string} menuSection - The section of the menu being interacted with.
   * @param {string} menuAction - The action being performed on the menu.
   * @param {Object} [additionalData={}] - Additional data to include in the event.
   */
  const trackMenuInteraction = (downloadLink, menuSection, menuAction, additionalData = {}) => {
    registerAction({
      event: 'menu_interaction',
      download_link: downloadLink || '',
      menu_action: menuAction || 'view',
      menu_section: menuSection || '',
      menu_subsection: '',
      ...additionalData,
    });
  };

  return {
    trackMenuInteraction,
  };
}
